import * as React from "react";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch, { SwitchProps } from "@mui/material/Switch";
import Box from "@mui/material/Box";

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({}));

export default function IosSwitch({
  checked,
  setChecked,
  onStatusChange,
}: {
  checked: any;
  setChecked: any;
  onStatusChange: (status: "Active" | "Inactive") => void;
}) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);
    onStatusChange(newChecked ? "Active" : "Inactive");
  };
  return (
    <Box className={`switch-container ${checked ? "active" : "inactive"}`}>
      <FormControlLabel
        control={<IOSSwitch checked={checked} onChange={handleChange} />}
        label={checked ? "Active" : "Inactive"}
      />
    </Box>
  );
}
